<a class="button" buttonStyle="raised" [spaCommonPhoneNumber]="contactConfiguration.phoneNumber" [showIcon]="true"></a>
<button buttonStyle="raised" [pectinCommand]="quickContactCommand">Quick Contact Form</button>
